import { Input } from '../components/ui/input';

/**
 * Format a number string with commas (e.g., "5000000" -> "5,000,000")
 */
export const formatWithCommas = (value) => {
  if (!value && value !== 0) return '';
  const str = String(value).replace(/[^0-9.]/g, '');
  const parts = str.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

/**
 * Remove commas from formatted string to get raw number
 */
export const removeCommas = (value) => {
  return String(value).replace(/,/g, '');
};

/**
 * Naira input component with auto-comma formatting
 */
export const NairaInput = ({ value, onChange, ...props }) => {
  const displayValue = formatWithCommas(value);

  const handleChange = (e) => {
    const raw = removeCommas(e.target.value);
    // Only allow numbers and one decimal point
    if (raw === '' || /^\d*\.?\d*$/.test(raw)) {
      onChange(raw);
    }
  };

  return (
    <Input
      type="text"
      inputMode="numeric"
      value={displayValue}
      onChange={handleChange}
      {...props}
    />
  );
};
